import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksFinanceAttributions(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTIONS,
		options
	)
}
function _getDoneWorksFinanceAttributionPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_PREVIEW,
		options
	)
}
function _getDoneWorksFinanceAttributionPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_POPUP,
		options
	)
}

function _createDoneWorksFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].CREATE_DONE_WORKS_FINANCE_ATTRIBUTION,
		options
	)
}

function _getDoneWorksFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION,
		options
	)
}

function _patchDoneWorksFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PATCH_DONE_WORKS_FINANCE_ATTRIBUTION,
		options
	)
}

function _putDoneWorksFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PUT_DONE_WORKS_FINANCE_ATTRIBUTION,
		options
	)
}

function _deleteDoneWorksFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].DELETE_DONE_WORKS_FINANCE_ATTRIBUTION,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTIONS]: _getDoneWorksFinanceAttributions,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_PREVIEW]: _getDoneWorksFinanceAttributionPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_POPUP]: _getDoneWorksFinanceAttributionPopup,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].CREATE_DONE_WORKS_FINANCE_ATTRIBUTION]: _createDoneWorksFinanceAttribution,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION]: _getDoneWorksFinanceAttribution,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PATCH_DONE_WORKS_FINANCE_ATTRIBUTION]: _patchDoneWorksFinanceAttribution,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PUT_DONE_WORKS_FINANCE_ATTRIBUTION]: _putDoneWorksFinanceAttribution,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].DELETE_DONE_WORKS_FINANCE_ATTRIBUTION]: _deleteDoneWorksFinanceAttribution,
}